import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=3d6481cd&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=ts&"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=3d6481cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6481cd",
  null
  
)

export default component.exports